<template>
  <div class="portfolio-chart-container">
    <h4 class="heading">{{ $t("portfolio structure") }}</h4>
    <div class="row portfolio-chart__controls controls">
      <fhs-select
        :options="selectTypes"
        @handleSelect="handleTypeConditionChange"
        class="controls__item"
      />
    </div>
    <!--    <pre>-->
    <!--          {{ portfolio_chart_drilldown(true) }}-->
    <!--        </pre-->
    <!--    >-->
    <!--    {{ totalAmount }}-->
    <!--      :total="$formatMoney(portfolio_chart.total, 0)"-->
    <div class="portfolio-chart__preloader" v-if="vpLoading">
      <spinner :animation-duration="1000" :size="60" :color="'#2E79EF'" />
    </div>
    <pie-amchart
      v-else
      :data="reformat_portfolio_chart"
      :drilldown="portfolio_chart_drilldown(true)"
      :currency="currency_selected"
      :total="totalAmount"
      @drilldown-status="categorySelected"
      class="portfolio-chart"
    />
  </div>
</template>

<script>
import SelectPrimary from "@/components/ui-kit/SelectPrimary";
import { HalfCircleSpinner } from "epic-spinners";
import { formatMoney } from "@/helpers/money";
import { mapGetters } from "vuex";
import PieAmchart from "@/components/ui-kit/PieAmchart.vue";
export default {
  components: {
    "fhs-select": SelectPrimary,
    // spinner: HalfCircleSpinner,
    "pie-amchart": PieAmchart
  },
  computed: {
    ...mapGetters(["isVpLoading"]),
    ...mapGetters({
      portfolio_chart: "getPortfolioDetailsCategoryForChart",
      portfolio_chart_drilldown: "getPortfolioDetailsCategory",
      portfolio_money_chart: "getMoneyForPortfolioChart",
      selectTypes: "getPortfolioSortTypesList",
      currency_selected: "getSelectedCurrencySign",
      vpLoading: "getPortfolioLoading"
    }),
    reformat_portfolio_chart() {
      return this.portfolio_chart.data.filter(each => {
        if (parseFloat(each.value) > 0) {
          each.value = parseFloat(each.value).toFixed(2);
          if (each) {
            return each;
          }
        }
      });
    },
    // WIP
    totalAmount() {
      let total = this.portfolio_chart.total;
      if (this.drilldownActive) {
        total = 0;
        let data = this.portfolio_chart_drilldown(this.drilldownActive) || {};
        // console.log(data[this.selectedCategory]);
        data[this.selectedCategory].forEach(each => {
          total += parseFloat(each.value);
        });
        // console.log(total);
        return this.$formatMoney(total, 0);
      }
      return this.$formatMoney(total, 0);
    }
  },
  data() {
    return {
      drilldownActive: false,
      selectedCategory: null
    };
  },
  methods: {
    categorySelected(value) {
      this.drilldownActive = value.category ? true : false;
      this.selectedCategory = this.drilldownActive ? value.category : null;
    },
    formatMoney,
    handleTypeConditionChange(sort_type) {
      this.$store.commit("setPortfolioSortCondition", sort_type);
    }
  },
  mounted() {
    // if (this.$store.user === null) {
    //   this.$store.dispatch("fetchAccountData");
    // }
  }
};
</script>

<style scoped>
.heading {
  font-size: 36px;
  font-weight: normal;
  color: #222c44;
}

.portfolio-chart {
  margin: 30px 0 80px;
}

.portfolio-chart-container {
  display: flex;
  flex-direction: column;
  position: relative;
}

.portfolio-chart__preloader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  z-index: 1000;
}

.portfolio-chart__controls {
  margin-top: 20px;
}

.controls__item {
  margin-right: 15px;
}

@media (max-width: 1100px) {
  .portfolio-chart {
    width: 100%;
    align-self: center;
  }
}
</style>
